export enum DpeTileStep {
  INTRO = 1,
  VALIDATION = 2,
  CONFIRMATION = 3,
}

export enum DpePartner {
  VITALITY = 'vitality',
}

export enum DpeLogoSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum DpeDisplayType {
  BUTTON = 'button',
  LABEL = 'label',
}

export type DpeData = {
  authData: DpeAuthData;
  tileData: DpeTileData;
};

interface DpeAbstractData {
  logo: string;
  introductionMessage: string;
}

export interface DpeAuthData extends DpeAbstractData {
  loginMessage: string;
  registrationMessage: string;
  passwordForgottenMessage: string;
}

export interface DpeTileData extends DpeAbstractData {
  shortIntroductionMessage: string;
  validationMessage: string;
  confirmationMessage: string;
}

export type VitalityCheckRequestObject = {
  dateOfBirth: string;
  membershipNumber: string;
};

export interface DpeAuthFormValues {
  email: string;
  firstName: string;
  gender: string;
  title: string;
  lastName: string;
  password: string;
  emailSubscribe: boolean;
  mailSubscribe: boolean;
}

export interface DpeEnrolmentWizardStepContext {
  from: DpeTileStep;
  to: DpeTileStep;
}
